import qs from "qs";

export default function stockItIncentivesReducer(state = {
  stock_it_incentives_outlets: [],
  stock_it_incentives_outlet_visit_data: {},
  stock_it_incentives_outlets_visit_data: [],
  stock_it_incentives: [],
  stock_it_incentive: [],
  paging: {
    number: 1,
    size: 10
  },
  meta: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_STOCK_IT_ELIGIBLE_OUTLETS_PENDING':
    case 'GET_STOCK_IT_INCENTIVES_OUTLET_VISIT_DATA_PENDING':
    case 'GET_STOCK_IT_INCENTIVES_OUTLETS_VISIT_DATA_PENDING':
    case 'GET_STOCK_IT_INCENTIVE_PENDING':
    case 'ADD_STOCK_IT_INCENTIVES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      }
    }
    case 'GET_STOCK_IT_INCENTIVES_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.paging;
      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it_incentives: action.payLoad.data,
        paging: page
      }
    }
    case 'GET_STOCK_IT_INCENTIVE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it_incentive: action.payLoad.data,
        meta: action.payLoad.meta
      }
    }
    case 'ADD_STOCK_IT_INCENTIVE_FULFILLED': {
      return {
        ...state
      }
    }
    case 'GET_STOCK_IT_ELIGIBLE_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it_incentives_outlets: action.payLoad.data,
      }
    }
    case 'GET_STOCK_IT_INCENTIVES_OUTLET_VISIT_DATA_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it_incentives_outlet_visit_data: action.payLoad.data,
      }
    }
    case 'GET_STOCK_IT_INCENTIVES_OUTLETS_VISIT_DATA': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stock_it_incentives_outlets_visit_data: action.payLoad.data,
      }
    }
    case 'GET_STOCK_IT_INCENTIVE_REJECTED':
    case 'ADD_STOCK_IT_INCENTIVES_REJECTED':{
      return {
        ...state,
        fetching: false,
        errors: action.payLoad.data.error,
      };
    }
    case 'GET_STOCK_IT_ELIGIBLE_OUTLETS_REJECTED':
    case 'GET_STOCK_IT_INCENTIVES_OUTLET_VISIT_DATA_REJECTED':
    case 'GET_STOCK_IT_INCENTIVES_OUTLETS_VISIT_DATA_REJECTED':
    case 'GET_STOCK_IT_INCENTIVES_REJECTED': {
      // return {...state, errors: action.payLoad.errors}
    }
    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stockItIncentivesReducer.js